/* eslint-disable */
window.addEventListener('load', () => {
  quoteBlock.init();
});

const quoteBlock = {
  init: function () {
    const sections = document.querySelectorAll('[data-quote-block-js]');

    if (!sections.length) return;

    sections.forEach((section) => {
      this.createDecoLine(section);
      this.decoLineWidth(section);

      window.addEventListener('resize', () => {
        this.decoLineWidth(section);
      });
    })

  },

  createDecoLine: function (section) {
    const quote = section.querySelector('[data-quote-js]');
    if (!quote) return null;

    const quoteFirstSpan = quote.querySelector('span');
    const decoLine = document.createElement('span');

    quoteFirstSpan.classList.add('first-span');
    decoLine.classList.add('deco-line');
    quoteFirstSpan.appendChild(decoLine);
  },

  calculateDecoLinePosition: function (quote, quoteFirstSpan) {
    const quoteCoordinates = quote.getBoundingClientRect();
    const computedStyles = window.getComputedStyle(quote);
    const transformMatrix = computedStyles.transform;
    const matrixComponents = transformMatrix.match(/matrix\(([^)]+)\)/)[1].split(', ');
    const horizontalShift = parseFloat(matrixComponents[4]);

    const firstSpanCoordinates = quoteFirstSpan.getBoundingClientRect();

    const animationTransformValue = (horizontalShift !== 0) ? 100 : 0;
    const decoWidth = firstSpanCoordinates.left - animationTransformValue;
    const decoPositionLeft = -firstSpanCoordinates.left + animationTransformValue;

    return {width: decoWidth, left: decoPositionLeft};
  },

  decoLineWidth: function (section) {
    const decoLine = section.querySelector('.deco-line');
    const quote = section.querySelector('[data-quote-js]');
    const quoteFirstSpan = quote.querySelector('span');
    if (!decoLine) return;

    const {width, left} = this.calculateDecoLinePosition(quote, quoteFirstSpan);

    decoLine.style.width = `${width}px`;
    decoLine.style.left = `${left}px`;
  },
}

export default quoteBlock;
